import styled from 'styled-components';

export const UploaderContent = styled.div`
  .anticon {
    margin-bottom: 8px;
    font-size: 2.5rem;
    color: ${({ theme }) => theme.colors.primary};
  }
`;
